import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import ChariotIcon from 'src/assets/svg/chariot.svg'
import { ReactComponent as CalendarIcon } from 'src/assets/svg/calendar.svg'
import { cn } from 'src/utils/cn'
import styles from './backNavigationButton.module.scss'

interface BackNavigationButtonProps {
  className?: string
  date?: string
  handleClick?: () => void
  title?: string
  url?: string
}

export const BackNavigationButton: FC<BackNavigationButtonProps> = ({
  title,
  url,
  handleClick,
  className,
  date,
}) => {
  const navigate = useNavigate()

  const onClick = () => {
    if (url) {
      navigate(url)

      return
    }

    if (handleClick) {
      handleClick()

      return
    }

    navigate(-1)
  }

  return (
    <div
      className={cn(styles.backNavigationButton, className)}
      style={{ cursor: 'pointer' }}
    >
      <div
        className={styles.clickableSection}
        onClick={onClick}
        style={{ cursor: 'pointer' }}
      >
        <img src={ChariotIcon} style={{ cursor: 'pointer' }} />

        <span className={styles.linkText} style={{ cursor: 'pointer' }}>
          {title}
        </span>
      </div>

      {date && (
        <div className={styles.dateSection}>
          <span className={styles.dateSeparator}>•</span>
          <CalendarIcon className={styles.calendarIcon} />
          <span className={styles.dateText}>{date}</span>
        </div>
      )}
    </div>
  )
}
